import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/common/BackButton";
import CustomiseSection from "../../components/collection/CustomiseSection";

// 1. The Individual Product Card Component
const EmbroideryCard = ({ product, onViewClick }) => {
    const [loupePos, setLoupePos] = useState({ x: 0, y: 0 });
    const [imagePos, setImagePos] = useState({ x: 0, y: 0 });
    const imageWrapperRef = useRef(null);

    // This function calculates the mouse position relative to the image container
    // and updates the position of the loupe circle and the image inside it.
    const handleMouseMove = (e) => {
        const { left, top, width, height } =
            imageWrapperRef.current.getBoundingClientRect();

        // Mouse coordinates relative to the wrapper
        const x = e.clientX - left;
        const y = e.clientY - top;

        // Update Loupe Position (centered on mouse)
        setLoupePos({ x, y });

        // Update magnified image position *inside* the loupe.
        // New Formula:
        // We want the point (x, y) on the small image to correspond to the center of the loupe.
        // The large image is at -x * scale, -y * scale relative to the origin.
        // We add loupeRadius to center that 'view' in the loupe div.

        const scale = 2.8; // Matches CSS width: 250%
        const loupeRadius = 90; // Matches CSS width/height: 180px / 2 = 90

        setImagePos({
            x: -(x * scale) + loupeRadius,
            y: -(y * scale) + loupeRadius,
        });
    };

    return (
        <div className="pe-card-wrapper">
            <div className="pe-card pe-static-card">
                {/* --- Image Wrapper with Mouse Tracking --- */}
                <div
                    className="pe-image-wrapper"
                    ref={imageWrapperRef}
                    onMouseMove={handleMouseMove}
                // On mouse leave, maybe reset? Optional, but feels smoother if left as is.
                >
                    {/* The "Base" Photo (Flat) */}
                    <img
                        src={product.imageBase}
                        alt={product.title}
                        className="pe-base-image"
                    />

                    {/* The Magnifying Loupe Circle */}
                    <div
                        className="pe-loupe"
                        style={{ top: `${loupePos.y}px`, left: `${loupePos.x}px` }}
                    >
                        {/* The "Textured" Embroidery Image inside the loupe */}
                        <img
                            src={product.imageTexture}
                            alt="Embroidery Detail"
                            className="pe-loupe-image"
                            style={{
                                transform: `translate(${imagePos.x}px, ${imagePos.y}px)`,
                            }}
                        />
                    </div>
                </div>

                {/* --- Card Details --- */}
                <div className="pe-details">
                    {/* Replaced Category with ID */}
                    <span className="pe-category">PRODUCT ID: {product.id}</span>
                    <h3 className="pe-title">{product.title}</h3>

                    <div className="pe-button-container">
                        <button className="pe-btn" onClick={() => onViewClick(product)}>Click to View</button>
                    </div>
                </div>
            </div>
        </div>
    );
};




// 2. Main Container displaying the grid
export default function Hankies() {
    const navigate = useNavigate();

    // DUMMY DATA - Replace with your real data
    // IMPT: Use real, high-res embroidery closeups for 'imageTexture'
    const products = [
        {
            id: 'HK-01',
            category: "Letter Handkerchief Embroidery",
            title: "Letter Handkerchief",
            price: "₹ 199",
            imageBase: "images/acc1.webp",
            imageTexture: "images/acc1.webp",
            description: "A delicate sunflower hand-embroidered handkerchief that adds a cheerful and elegant touch to everyday essentials.",
            highlights: ["Hand-embroidered floral motif", "Soft cotton fabric", "Elegant everyday accessory"]
        },
        {
            id: 'HK-02',
            category: "Kids Handkerchief Embroidery",
            title: "Kids Handkerchief",
            price: "₹ 249",
            imageBase: "images/acc5.webp",
            imageTexture: "images/acc5.webp",
            description: "An adorable embroidered handkerchief featuring playful designs, perfect for kids and gifting.",
            highlights: ["Cute character embroidery", "Skin-friendly fabric", "Perfect for kids & gifts"]
        },
        {
            id: 'HK-03',
            category: "Cultural Handkerchiefs",
            title: "Cultural Handkerchief",
            price: "₹ 269",
            imageBase: "images/hankie1.webp",
            imageTexture: "images/hankie1.webp",
            description: "A personalized embroidered handkerchief crafted with fine threadwork, making it a thoughtful and meaningful gift.",
            highlights: ["Custom name embroidery", "Neat hand stitching", "Ideal for return gifts"]
        },
        {
            id: 'HK-04',
            category: "Classic Floral Handkerchiefs",
            title: "Classic Floral Handkerchief",
            price: "₹ 199",
            imageBase: "images/hankie2.webp",
            imageTexture: "images/hankie2.webp",
            description: "A beautifully embroidered handkerchief with subtle floral patterns, designed for everyday elegance.",
            highlights: ["Minimal floral embroidery", "Premium cotton base", "Timeless design"]
        },
        {
            id: 'HK-05',
            category: "Personalized Handkerchief Embroidery",
            title: "Personalized Handkerchief",
            price: "₹ 249",
            imageBase: "images/hankie3.webp",
            imageTexture: "images/hankie3.webp",
            description: "A culturally inspired embroidered handkerchief showcasing traditional script and craftsmanship.",
            highlights: ["Traditional embroidery style", "Durable thread finish", "Unique handcrafted piece"]
        },
    ];




    const handleViewProduct = (product) => {
        navigate('/product-view', { state: { product } });
    };

    return (
        <>
            <section className="pe-section">
                <div style={{ padding: "0 5%", maxWidth: "1200px", margin: "0 auto", marginTop: "20px" }}>
                    <BackButton />
                </div>
                <div className="pe-header">
                    <h2 className="pe-main-title">❖ Hankies Collection ❖</h2>
                    <div className="pe-thread-line"></div>
                    <p className="pe-subtitle">
                        Add charm to everyday moments with delicately embroidered hankies, handcrafted for subtle elegance and personal expression.
                    </p>
                </div>

                <div className="pe-grid">
                    {products.map((product) => (
                        <EmbroideryCard key={product.id} product={product} onViewClick={handleViewProduct} />
                    ))}

                </div>
            </section>
            <CustomiseSection />
        </>
    );
}

